<template style="background-color: white;">

    <div style="background-color: white;">
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div>
        <br> -->
      
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>

              <div class="d-flex justify-end" v-if="is_admin">
      <v-btn 
       v-if="!is_admin"
        color="brand onBrand--text"
        dark
        small
        class="mb-2,mt-2"
        style="border-radius:8px"
        @click="videoDialog = true"
      >
      <v-icon left>mdi-youtube</v-icon>
      Watch Tutorial
      </v-btn>
      </div>

            <v-card class="box no-display">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Freez / Unfreez Salary Register</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3" md="3" class="pt-3">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="year" :items="year_list"
                            item-text="name" item-value="id" label="Salary Year" outlined @change="getSalaryMonth()" />
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-3" v-if="year">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="sal_month" return-object
                            :items="sal_month_list" item-text="sal_mon" item-value="id" label="Salary Month" outlined />
                    </v-col>
                    <v-col cols="12" sm="3" md="3" v-if="sal_month">
                        <v-btn class="button" @click="fetchSalarySlip()">Fetch Salary Slip</v-btn>
                    </v-col>
                </v-row>
            </v-card>
        </v-container>
        <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span>Freeze/Unfreeze Salary Register Tutorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/cW9NTUn6QSs?si=0mqdYn4j5UokJYch"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
    </div>
    <!-- /. root div -->
</template>
<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data: () => ({
            loader: false,
            snackbar_msg: "",
            color: "",
            // extraBreadcrumbItems: [


            // ],
            // breadcrumbClass: "breadcrumb-style1",
            snackbar: false,
            title: "",
            description: "",
            videoDialog:false,
            sal_month_list: [],
            sal_month: null,
            year: null,
            year_list: [],
            fmsg: null,
        }),
        methods: {
            fetchSalarySlip() {
                localStorage.setItem("sal_month", this.sal_month.id);
                if (this.tenant === 'sanjivani') {
                    let routeData = this.$router.resolve({
                    name: "print-pay-slip-sanjivani",
                    });
                    window.open(routeData.href, "_blank");
                 } 
                 else{
                    let routeData = this.$router.resolve({
                    name: "print-pay-slip",
                    });
                    window.open(routeData.href, "_blank");
                    }
            },
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            onLoad() {
                axios
                    .post("/Payroll/getYear")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.year_list = res.data.year_list;
                            if (res.data.is_admin !== undefined) {
                this.is_admin = res.data.is_admin;
            }

                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
            getSalaryMonth() {
                // this.sal_month = null,
                // this.sal_month_list = []
                const data = {
                    year: this.year,
                };
                axios
                    .post("/Payroll/getSalaryMonth", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.sal_month_list = res.data.sal_month_list;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        mounted() {
            this.tenant = localStorage.getItem("EPS-tenant");
            this.onLoad();
        },
        watch: {},
    };
</script>
<style scoped>
    /* .v-text-field{
      width: 80px;
} */
    hr {
        width: 100%;
        color: gray;
    }
    thead {
        font-weight: bold !important;
    }
    th,
    td {
        font-weight: bold !important;
    }
    tr,
    td,
    th {
        border-collapse: collapse;
        border: 1px solid black;
        height: 40px;
    }
    tr,
    tbody {
        border-bottom: 1px solid black;
        border-collapse: collapse;
        border: 1px solid black;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
        }
        td + td,
        th + th {
            width: auto;
        }
    }
    table {
        white-space: nowrap !important;
        border-collapse: collapse;
        width: 100%;
    }

    @media print {
        @page {
            size: A4 !important;
            margin-top: none !important;
            padding-top: none !important;
        }
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
    }
</style>
